module.exports = __webpack_public_path__ + "static/media/commissions3.3b81a026.png";